<template>
  <import-data-view type="geo" title="Гео"></import-data-view>
</template>

<script>
    import ImportDataView from '@/components/import/ImportDataView';

    export default {
        components: {
            ImportDataView,
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/ui/ImportGeo.vue